import { useMemo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { createUrlResourcePromptMenuItem, PROMPT_MENU_TYPE } from '../../lib';
import { BaseItemsList } from '../BaseItemsList';
import { MenuItem } from '../MenuItem';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  urlResources: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onAction: PropTypes.func.isRequired,
  quickSearchMode: PropTypes.bool,
  noTags: PropTypes.bool,
  additionalItem: PropTypes.shape(),
};

const defaultProps = {
  className: '',
  quickSearchMode: false,
  noTags: false,
  additionalItem: null,
};

export const ItemsUrl = ({
  className,
  urlResources,
  onAction,
  quickSearchMode,
  noTags,
  additionalItem,
}) => {
  const styles = useStyles();

  const menuItems = useMemo(
    () => urlResources?.map(createUrlResourcePromptMenuItem),
    [urlResources]
  );

  return (
    <BaseItemsList className={cx(styles.root, className)}>
      {menuItems.map((item) => (
        <MenuItem
          key={item.id}
          type={PROMPT_MENU_TYPE.url}
          item={item}
          onAction={onAction}
          menuType={PROMPT_MENU_TYPE.url}
          quickSearchMode={quickSearchMode}
          noTags={noTags}
        />
      ))}

      {additionalItem && (
        <MenuItem
          type={PROMPT_MENU_TYPE.url}
          item={additionalItem}
          onAction={onAction}
          menuType={PROMPT_MENU_TYPE.url}
          quickSearchMode={quickSearchMode}
          noTags={noTags}
        />
      )}
    </BaseItemsList>
  );
};

ItemsUrl.displayName = 'ItemsUrl';
ItemsUrl.propTypes = propTypes;
ItemsUrl.defaultProps = defaultProps;
